function getArrivedFromExternalSite(referrer, hostName, environment) {
    if (!referrer) {
        return true;
    }

    let referrerBase = referrer.split('?')[0].split('#')[0];

    // For local and selenium testing, allow pdp-to-pdp link within
    // the same local/testing environment to qualify as on-site traffic
    const isLocalhostInReferrer =
        process.env.NODE_ENV === 'development' && referrerBase.indexOf('localhost:8080') > -1;
    const isLoadBalancerInReferrer =
        (environment === 'test' || environment === 'stage') &&
        referrerBase.indexOf(`${environment}.aws.away.black`) > -1;
    const isHostNameInReferrer = referrerBase.indexOf(hostName) > -1;
    const isHomeawayInReferrer = referrerBase.indexOf('homeaway') > -1;
    const arrivedFromExternalSite =
        !isLocalhostInReferrer &&
        !isLoadBalancerInReferrer &&
        !isHostNameInReferrer &&
        !isHomeawayInReferrer;

    return arrivedFromExternalSite;
}

export {getArrivedFromExternalSite};
